import React, { useState, useEffect } from "react";
import "./navbar.scss";
import { Link } from "react-router-dom";

function Navbar() {
  const [open, setOpen] = useState(false);

    useEffect(() => {
    if (open) {
      document.body.classList.add("menu-open-background");
    } else {
      document.body.classList.remove("menu-open-background");
    }
  }, [open]);

  return (
    <nav className="navbar">
      {/* Mobile Hamburger */}
      <div className="mobile-menu-icon" onClick={() => setOpen(!open)}>
        <div className={open ? "bar open" : "bar"}></div>
        <div className={open ? "bar open" : "bar"}></div>
        <div className={open ? "bar open" : "bar"}></div>
      </div>

      {/* Left */}
      <div className="nav-left desktop-only">
        <ul>
          <Link to="/"><li>HOME</li></Link>
          <Link to="/about"><li>ABOUT</li></Link>
          <Link to="/services"><li>SERVICES</li></Link>
          <Link to="/career"><li>CAREER</li></Link>
        </ul>
      </div>

      {/* Center Logo */}
      <div className="nav-center">
        <Link to="/">
          <img
            src="https://res.cloudinary.com/dsnontai6/image/upload/v1762109180/daily-help-united-high-resolution-logo-grayscale-transparent-2_ttattq.png"
            alt="Logo"
          />
        </Link>
      </div>

      {/* Right */}
      <div className="nav-right desktop-only">
        <Link to="/contact">
          <button>Contact Us</button>
        </Link>
      </div>

      {/* Mobile Menu */}
      <div className={`mobile-menu ${open ? "show" : ""}`}>
        <div className="left-men">
          <div className="mobile-menu-icon" onClick={() => setOpen(!open)}>
          <div className={open ? "bar open" : "bar"}></div>
          <div className={open ? "bar open" : "bar"}></div>
          <div className={open ? "bar open" : "bar"}></div>
        </div>
      </div>
        <ul>
          <Link to="/" onClick={() => setOpen(false)}><li>HOME</li></Link>
          <Link to="/about" onClick={() => setOpen(false)}><li>ABOUT</li></Link>
          <Link to="/services" onClick={() => setOpen(false)}><li>SERVICES</li></Link>
          <Link to="/career" onClick={() => setOpen(false)}><li>CAREER</li></Link>
          <Link to="/contact" onClick={() => setOpen(false)}>
            <li className="mobile-contact-btn">Contact Us</li>
          </Link>
        </ul>
      </div>
    </nav>
  );
}

export default Navbar;
